import { Action } from '@ngrx/store';

import { ReadingIntentionsKey } from '®shared/annotations';

import {
  ReadingIntentionsByResourceId,
  StudyNotesByResourceId,
} from './user-annotations.state';

export enum UserAnnotationsActionTypes {
  FETCH_USER_ANNOTATIONS_FOR_LIST = '[User Annotations] Fetch user annotations for list',
  USER_ANNOTATIONS_FOR_LIST_LOADED = '[User Annotations] User annotations for list loaded',
  USER_ANNOTATIONS_FOR_LIST_LOADING_FAILED = '[User Annotations] User annotations for list loading failed',
  UPDATE_READING_INTENTION = '[User Annotations] Update reading intention',
  UPDATE_READING_INTENTION_SUCCEEDED = '[User Annotations] Update reading intention succeeded',
  UPDATE_READING_INTENTION_FAILED = '[User Annotations] Update reading intention failed',
  DELETE_READING_INTENTION = '[User Annotations] Delete reading intention',
  DELETE_READING_INTENTION_SUCCEEDED = '[User Annotations] Delete reading intention succeeded',
  DELETE_READING_INTENTION_FAILED = '[User Annotations] Delete reading intention failed',
  UPDATE_STUDY_NOTE = '[User Annotations] Update study note',
  UPDATE_STUDY_NOTE_SUCCEEDED = '[User Annotations] Update study note succeeded',
  UPDATE_STUDY_NOTE_FAILED = '[User Annotations] Update study note failed',
  DELETE_STUDY_NOTE = '[User Annotations] Delete study note',
  DELETE_STUDY_NOTE_SUCCEEDED = '[User Annotations] Delete study note succeeded',
  DELETE_STUDY_NOTE_FAILED = '[User Annotations] Delete study note failed',
}

export interface ListAndUserIdPayload {
  listId: string;
  userId: string;
}

export class FetchUserAnnotationsForListAction implements Action {
  readonly type = UserAnnotationsActionTypes.FETCH_USER_ANNOTATIONS_FOR_LIST;

  constructor(public payload: ListAndUserIdPayload) {}
}

export interface UserAnnotationsPayload extends ListAndUserIdPayload {
  readingIntentionsByResource: ReadingIntentionsByResourceId;
  studyNotesByResource: StudyNotesByResourceId;
}

export class UserAnnotationsForListLoadedAction implements Action {
  readonly type = UserAnnotationsActionTypes.USER_ANNOTATIONS_FOR_LIST_LOADED;

  constructor(public payload: UserAnnotationsPayload) {}
}

export interface UserAnnotationsErrorPayload extends ListAndUserIdPayload {
  error: any;
}

export class UserAnnotationsForListLoadingFailedAction implements Action {
  readonly type =
    UserAnnotationsActionTypes.USER_ANNOTATIONS_FOR_LIST_LOADING_FAILED;

  constructor(public payload: UserAnnotationsErrorPayload) {}
}

export interface UpdateReadingIntentionPayload {
  userId: string;
  resourceId: string;
  status: ReadingIntentionsKey;
}

export class UpdateReadingIntentionAction implements Action {
  readonly type = UserAnnotationsActionTypes.UPDATE_READING_INTENTION;

  constructor(public payload: UpdateReadingIntentionPayload) {}
}

export class UpdateReadingIntentionSucceededAction implements Action {
  readonly type = UserAnnotationsActionTypes.UPDATE_READING_INTENTION_SUCCEEDED;

  constructor(public payload: UpdateReadingIntentionPayload) {}
}

export interface UpdateReadingIntentionFailedPayload
  extends UpdateReadingIntentionPayload {
  error: any;
}

export class UpdateReadingIntentionFailedAction implements Action {
  readonly type = UserAnnotationsActionTypes.UPDATE_READING_INTENTION_FAILED;

  constructor(public payload: UpdateReadingIntentionFailedPayload) {}
}

export interface DeleteReadingIntentionPayload {
  userId: string;
  resourceId: string;
}

export class DeleteReadingIntentionAction implements Action {
  readonly type = UserAnnotationsActionTypes.DELETE_READING_INTENTION;

  constructor(public payload: DeleteReadingIntentionPayload) {}
}

export class DeleteReadingIntentionSucceededAction implements Action {
  readonly type = UserAnnotationsActionTypes.DELETE_READING_INTENTION_SUCCEEDED;

  constructor(public payload: DeleteReadingIntentionPayload) {}
}

export interface DeleteReadingIntentionFailedPayload
  extends DeleteReadingIntentionPayload {
  error: any;
}

export class DeleteReadingIntentionFailedAction implements Action {
  readonly type = UserAnnotationsActionTypes.DELETE_READING_INTENTION_FAILED;

  constructor(public payload: DeleteReadingIntentionFailedPayload) {}
}

export interface UpdateStudyNotePayload {
  userId: string;
  resourceId: string;
  note: string;
}

export class UpdateStudyNoteAction implements Action {
  readonly type = UserAnnotationsActionTypes.UPDATE_STUDY_NOTE;

  constructor(public payload: UpdateStudyNotePayload) {}
}

export class UpdateStudyNoteSucceededAction implements Action {
  readonly type = UserAnnotationsActionTypes.UPDATE_STUDY_NOTE_SUCCEEDED;

  constructor(public payload: UpdateStudyNotePayload) {}
}

export interface UpdateStudyNoteFailedPayload extends UpdateStudyNotePayload {
  error: any;
}

export class UpdateStudyNoteFailedAction implements Action {
  readonly type = UserAnnotationsActionTypes.UPDATE_STUDY_NOTE_FAILED;

  constructor(public payload: UpdateStudyNoteFailedPayload) {}
}

export interface DeleteStudyNotePayload {
  userId: string;
  resourceId: string;
}

export class DeleteStudyNoteAction implements Action {
  readonly type = UserAnnotationsActionTypes.DELETE_STUDY_NOTE;

  constructor(public payload: DeleteStudyNotePayload) {}
}

export class DeleteStudyNoteSucceededAction implements Action {
  readonly type = UserAnnotationsActionTypes.DELETE_STUDY_NOTE_SUCCEEDED;

  constructor(public payload: DeleteStudyNotePayload) {}
}

export interface DeleteStudyNoteFailedPayload extends DeleteStudyNotePayload {
  error: any;
}

export class DeleteStudyNoteFailedAction implements Action {
  readonly type = UserAnnotationsActionTypes.DELETE_STUDY_NOTE_FAILED;

  constructor(public payload: DeleteStudyNoteFailedPayload) {}
}

export type UserAnnotationsActions =
  | FetchUserAnnotationsForListAction
  | UserAnnotationsForListLoadedAction
  | UserAnnotationsForListLoadingFailedAction
  | UpdateReadingIntentionAction
  | UpdateReadingIntentionSucceededAction
  | UpdateReadingIntentionFailedAction
  | DeleteReadingIntentionAction
  | DeleteReadingIntentionSucceededAction
  | DeleteReadingIntentionFailedAction
  | UpdateStudyNoteAction
  | UpdateStudyNoteSucceededAction
  | UpdateStudyNoteFailedAction
  | DeleteStudyNoteAction
  | DeleteStudyNoteSucceededAction
  | DeleteStudyNoteFailedAction;
